export default __webpack_public_path__ + "static/media/solid-down.a29f52fa.svg";